// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pages.css - UPDATED FOR LIGHT THEME */

/* General page container with proper navbar spacing */
.page-container {
  min-height: calc(100vh - var(--navbar-height)); /* Use global navbar height */
  padding: 2rem 1rem 4rem;
  /* background: var(--gradient-hero); /* Replaced complex gradient */
  padding-top: var(--navbar-height);
  /* Use a simpler light background */
  background-color: var(--bg-secondary); /* Use light secondary background */
}

.page-container .content-section h2 {
  text-align: center; /* Center the h2 heading within the content section */
  margin-bottom: 2.5rem; /* Add a bit more space below the centered heading */
}

.page-container h1 {
  text-align: center;
  font-size: 2.8rem;
  color: var(--text-primary); /* Dark text */
  margin-bottom: 1rem;
  font-weight: 600;
  line-height: 1.2;
}

.page-subtitle {
  text-align: center;
  font-size: 1.2rem;
  color: var(--text-secondary); /* Medium gray text */
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
  margin-bottom: 2rem; /* Added margin */
}

.content-section {
  max-width: 900px;
  margin: 0 auto 3rem;
  color: var(--text-primary); /* Dark text */
  line-height: 1.8;
  padding: 0 1rem;
}

.content-section h2 {
  color: var(--text-accent); /* Red accent text */
  margin: 3rem 0 1.5rem;
  font-size: 1.8rem;
  font-weight: 500;
}

.lead-text {
  font-size: 1.3rem;
  margin-bottom: 2rem;
  text-align: center;
  font-weight: 400;
  color: var(--text-secondary); /* Medium gray text */
}

/* CTA Section (Light Theme) */
.cta-section {
  text-align: center;
  margin: 4rem auto;
  padding: 3rem 2rem;
  background: var(--bg-primary); /* White background */
  border-radius: var(--border-radius-2xl);
  border: 1px solid var(--border-primary); /* Light gray border */
  max-width: 800px;
  box-shadow: var(--shadow-xl); /* Add shadow */
}

.cta-section h2 {
  color: var(--text-primary); /* Dark text */
  margin-bottom: 2rem;
  font-size: 2rem;
}

/* Contact Page Layout - Simplified for light theme */
.contact-content {
  display: grid;
  grid-template-columns: 1fr; /* Stack info and form */
  gap: 3rem; /* Adjusted gap */
  max-width: 700px; /* Narrower max-width */
  margin: 0 auto;
  align-items: start;
}

.contact-info h2 {
  color: var(--text-accent); /* Red accent */
  margin-bottom: 1.5rem;
  font-size: 2rem;
  text-align: center;
}

.contact-info p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  color: var(--text-secondary); /* Medium gray */
  text-align: center;
}

.contact-details {
  margin-top: 2rem;
  display: grid; /* Use grid for details too */
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}

.contact-item {
  margin-bottom: 0; /* Remove margin as grid handles gap */
  padding: 1.5rem;
  background: var(--bg-secondary); /* Light gray background */
  border-radius: var(--border-radius-lg);
  border: 1px solid var(--border-primary); /* Light border */
  transition: all 0.3s ease;
  text-align: center;
}

.contact-item:hover {
  border-color: var(--text-accent); /* Red border */
  background: var(--bg-primary); /* White on hover */
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

.contact-item h3 {
  color: var(--text-primary); /* Dark text */
  margin-bottom: 0.8rem;
  font-size: 1.3rem;
}

.contact-item p, .contact-item a {
  color: var(--text-secondary); /* Medium gray */
  font-size: 1rem;
  text-decoration: none;
}
.contact-item a:hover {
  color: var(--text-accent); /* Red link hover */
}

/* Contact Form Styling (Light Theme) */
.contact-form-section h2 {
  color: var(--text-accent); /* Red accent */
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.contact-form .form-group {
  display: flex;
  flex-direction: column;
}

.contact-form label {
  color: var(--text-primary); /* Dark label */
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 1rem;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 1rem 1.2rem;
  border: 1px solid var(--border-primary); /* Light border */
  border-radius: var(--border-radius-lg);
  background: var(--bg-secondary); /* Light gray background */
  color: var(--text-primary); /* Dark text */
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  transition: all 0.3s ease;
}

.contact-form input:focus,
.contact-form textarea:focus {
  outline: none;
  border-color: var(--text-accent); /* Red border */
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15); /* Red ring */
  background: var(--bg-primary); /* White background */
}

.contact-form textarea {
  min-height: 120px;
  resize: vertical;
}

.contact-form input::placeholder,
.contact-form textarea::placeholder {
  color: #9CA3AF; /* gray-400 equivalent */
}

/* Blog Page Layout (Light Theme) */
.blog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); /* Adjusted min size */
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem; /* Add padding */
}

.blog-card {
  background: var(--bg-primary); /* White background */
  border: 1px solid var(--border-primary); /* Light border */
  border-radius: var(--border-radius-xl); /* Consistent rounding */
  padding: 2rem; /* Adjusted padding */
  transition: all 0.3s ease;
  height: auto; /* Allow natural height */
  box-shadow: var(--shadow-lg);
}

.blog-card:hover {
  transform: translateY(-5px);
  border-color: var(--text-accent); /* Red border */
  box-shadow: var(--shadow-xl);
}

.blog-card h2 {
  color: var(--text-primary); /* Dark text */
  font-size: 1.5rem;
  margin-bottom: 0.8rem;
  font-weight: 600;
  line-height: 1.3;
}

.blog-date {
  color: var(--text-secondary); /* Medium gray */
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-weight: 500;
}

.blog-excerpt {
  color: var(--text-secondary); /* Medium gray */
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.read-more {
  color: var(--text-accent); /* Red accent */
  text-decoration: none;
  font-weight: 600; /* Bolder */
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.read-more:hover {
  color: var(--primary-red-dark); /* Darker red */
  transform: translateX(5px);
}

/* Legal Pages Layout (Light Theme) */
.legal-content {
  max-width: 800px;
  margin: 2rem auto; /* Added top margin */
  color: var(--text-secondary); /* Medium gray base text */
  line-height: 1.8;
  padding: 2rem; /* Add padding */
  background: var(--bg-primary); /* White background */
  border: 1px solid var(--border-primary); /* Light border */
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-lg);
}

.legal-content h2 {
  color: var(--text-primary); /* Dark heading */
  margin: 3rem 0 1.5rem;
  font-size: 1.8rem;
  font-weight: 600; /* Bolder heading */
}

.legal-content p {
  margin-bottom: 1.5rem;
  font-size: 1rem;
}

.last-updated {
  color: var(--text-secondary); /* Medium gray */
  font-style: italic;
  margin-bottom: 2rem;
  text-align: right; /* Align right */
  font-size: 0.9rem; /* Smaller text */
}

/* Process Steps Layout (Looks okay, uses light theme styles already) */
.process-steps {
  display: grid; /* Use grid for better alignment */
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem; /* Increased gap */
  margin-top: 3rem;
  max-width: 1100px; /* Adjusted width */
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}
.process-step {
  background: var(--bg-primary); /* White */
  border: 1px solid var(--border-primary); /* Light gray border */
  border-radius: var(--border-radius-xl);
  padding: 2rem 1.5rem; /* Adjusted padding */
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  box-shadow: var(--shadow-lg);
}

.process-step:hover {
  transform: translateY(-5px);
  border-color: var(--text-accent);
  box-shadow: var(--shadow-xl);
}

.step-icon {
  width: 60px;
  height: 60px;
  background: var(--gradient-button); /* Red gradient */
  color: var(--text-on-gradient); /* White text */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 1.5rem;
  font-weight: 600;
  box-shadow: var(--shadow-lg);
}

.process-step h3 {
  color: var(--text-primary); /* Dark text */
  margin-bottom: 1rem;
  font-size: 1.3rem;
  font-weight: 600; /* Bolder */
}

.process-step p {
  color: var(--text-secondary); /* Medium gray text */
  font-size: 0.95rem;
  line-height: 1.6; /* Increased line height */
}

/* CTA Button Styling (Use primary auth button style) */
.cta-button.primary {
  /* Inherit from .auth-button if available globally, otherwise define here */
  display: inline-flex;
  background-image: var(--gradient-button);
  background-color: var(--primary-red-medium);
  color: white;
  padding: 1rem 2.5rem;
  border-radius: var(--border-radius-full);
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  margin-top: 1rem;
  border: none;
  box-shadow: var(--shadow-lg);
}

.cta-button.primary:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-button-hover);
}

/* Secondary CTA Button (Light theme adaptation) */
.cta-button.secondary {
  display: inline-flex;
  background: transparent;
  border: 2px solid var(--text-accent); /* Red border */
  color: var(--text-accent); /* Red text */
  padding: calc(1rem - 2px) calc(2.5rem - 2px); /* Adjust padding for border */
  border-radius: var(--border-radius-full);
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.cta-button.secondary:hover {
  background: var(--text-accent); /* Red background */
  color: white; /* White text */
  transform: translateY(-3px);
  box-shadow: var(--shadow-button-hover);
}


/* Responsive Design Improvements */
@media (max-width: 768px) {
  .page-container {
    padding: 3rem 1rem 3rem; /* Adjust padding */
    padding-top: var(--navbar-height);
  }

  .page-container h1 { font-size: 2.2rem; }
  .page-subtitle { font-size: 1.1rem; margin-bottom: 2rem; }
  .content-section { padding: 0 0.5rem; }
  .contact-content { grid-template-columns: 1fr; gap: 2.5rem; }
  .contact-item { padding: 1.5rem; }
  .blog-grid { grid-template-columns: 1fr; padding: 0 0.5rem; }
  .blog-card { padding: 2rem; }
  .process-steps { grid-template-columns: 1fr; padding: 0 0.5rem; gap: 1.5rem; }
  .process-step { padding: 2rem 1rem; }
  .cta-section { margin: 2rem 0.5rem; padding: 2rem 1.5rem; }
  .legal-content { padding: 1rem; margin: 1rem auto; } /* Adjust legal padding */
}

@media (max-width: 480px) {
  .page-container { padding: 2rem 0.5rem 2rem; padding-top: var(--navbar-height); }
  .page-container h1 { font-size: 1.8rem; }
  .page-subtitle { font-size: 1rem; }
  .content-section h2 { font-size: 1.5rem; margin: 2rem 0 1rem; }
  .lead-text { font-size: 1.1rem; }
  .contact-item { padding: 1.2rem; }
  .contact-item h3 { font-size: 1.1rem; }
  .blog-card { padding: 1.5rem; }
  .blog-card h2 { font-size: 1.3rem; }
  .process-step { padding: 1.5rem; }
  .step-icon { width: 50px; height: 50px; font-size: 1.2rem; }
  .process-step h3 { font-size: 1.1rem; }
  .cta-section { padding: 1.5rem 1rem; }
  .cta-section h2 { font-size: 1.6rem; }
  .cta-button { padding: 0.8rem 2rem; font-size: 1rem; width: 100%; max-width: 300px; }
  .legal-content h2 { font-size: 1.4rem; }
}

/* Blog Page Layout */
.blog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.blog-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: var(--border-radius-xl);
  padding: 2rem;
  transition: all 0.3s ease;
  height: auto;
  box-shadow: var(--shadow-lg);
}

.blog-card:hover {
  transform: translateY(-5px);
  border-color: var(--text-accent);
  box-shadow: var(--shadow-xl);
}

.blog-card h2 {
  color: var(--text-primary);
  font-size: 1.5rem;
  margin-bottom: 0.8rem;
  font-weight: 600;
  line-height: 1.3;
}

.blog-card-thumbnail {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: var(--border-radius-lg);
  margin-bottom: 1.25rem;
}

.blog-date {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-weight: 500;
}

.blog-excerpt {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.blog-error {
  text-align: center;
  color: var(--text-secondary);
  max-width: 600px;
  margin: 2rem auto;
  font-size: 1.05rem;
}

.read-more {
  color: var(--text-accent);
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.read-more:hover {
  color: var(--primary-red-dark);
  transform: translateX(5px);
}

/* Blog Post Detail Page */
.blog-post-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.blog-back-link {
  display: inline-block;
  margin-bottom: 1.5rem;
  color: var(--text-accent);
  text-decoration: none;
  font-weight: 600;
}

.blog-back-link:hover {
  color: var(--primary-red-dark);
}

.blog-post-thumbnail {
  width: 100%;
  max-height: 420px;
  object-fit: cover;
  border-radius: var(--border-radius-xl);
  margin-bottom: 1.5rem;
}

.blog-post-article h1 {
  color: var(--text-primary);
  font-size: 2.2rem;
  line-height: 1.3;
  margin-bottom: 0.5rem;
}

.blog-post-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.75rem 0 1.5rem;
}

.blog-post-category-tag {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  color: var(--text-secondary);
  border-radius: var(--border-radius-lg);
  padding: 0.25rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 500;
}

.blog-post-content {
  color: var(--text-primary);
  font-size: 1.05rem;
  line-height: 1.8;
}

.blog-post-content img {
  max-width: 100%;
  height: auto;
  border-radius: var(--border-radius-lg);
  margin: 1rem 0;
}

.blog-post-content a {
  color: var(--text-accent);
}

.blog-post-content blockquote {
  border-left: 4px solid var(--text-accent);
  padding-left: 1rem;
  color: var(--text-secondary);
  font-style: italic;
  margin: 1.5rem 0;
}

@media (max-width: 768px) {
  .blog-grid { grid-template-columns: 1fr; padding: 0 0.5rem; }
  .blog-card { padding: 1.5rem; }
  .blog-post-article h1 { font-size: 1.6rem; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Pages.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC,sDAAsD;AACtD;EACE,8CAA8C,EAAE,6BAA6B;EAC7E,uBAAuB;EACvB,mEAAmE;EACnE,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC,EAAE,mCAAmC;AAC5E;;AAEA;EACE,kBAAkB,EAAE,qDAAqD;EACzE,qBAAqB,EAAE,oDAAoD;AAC7E;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B,EAAE,cAAc;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B,EAAE,qBAAqB;EACnD,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,iBAAiB;AACxC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B,EAAE,cAAc;EAC1C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B,EAAE,qBAAqB;AACrD;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B,EAAE,qBAAqB;EACpD,uCAAuC;EACvC,uCAAuC,EAAE,sBAAsB;EAC/D,gBAAgB;EAChB,4BAA4B,EAAE,eAAe;AAC/C;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,0BAA0B,EAAE,wBAAwB;EACpD,SAAS,EAAE,iBAAiB;EAC5B,gBAAgB,EAAE,uBAAuB;EACzC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B,EAAE,gBAAgB;EAC9C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa,EAAE,6BAA6B;EAC5C,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,gBAAgB,EAAE,sCAAsC;EACxD,eAAe;EACf,+BAA+B,EAAE,0BAA0B;EAC3D,sCAAsC;EACtC,uCAAuC,EAAE,iBAAiB;EAC1D,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC,EAAE,eAAe;EACjD,6BAA6B,EAAE,mBAAmB;EAClD,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B,EAAE,gBAAgB;EAC9C,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA,uCAAuC;AACvC;EACE,yBAAyB,EAAE,eAAe;EAC1C,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B,EAAE,eAAe;EAC3C,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,uCAAuC,EAAE,iBAAiB;EAC1D,sCAAsC;EACtC,+BAA+B,EAAE,0BAA0B;EAC3D,0BAA0B,EAAE,cAAc;EAC1C,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gCAAgC,EAAE,eAAe;EACjD,6CAA6C,EAAE,aAAa;EAC5D,6BAA6B,EAAE,qBAAqB;AACtD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc,EAAE,wBAAwB;AAC1C;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,4DAA4D,EAAE,sBAAsB;EACpF,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB,EAAE,gBAAgB;AACtC;;AAEA;EACE,6BAA6B,EAAE,qBAAqB;EACpD,uCAAuC,EAAE,iBAAiB;EAC1D,sCAAsC,EAAE,wBAAwB;EAChE,aAAa,EAAE,qBAAqB;EACpC,yBAAyB;EACzB,YAAY,EAAE,yBAAyB;EACvC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC,EAAE,eAAe;EACjD,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B,EAAE,gBAAgB;EAC9C,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B,EAAE,gBAAgB;EAC9C,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,qBAAqB;EACrB,gBAAgB,EAAE,WAAW;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,8BAA8B,EAAE,eAAe;EAC/C,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,iBAAiB,EAAE,qBAAqB;EACxC,4BAA4B,EAAE,0BAA0B;EACxD,gBAAgB;EAChB,aAAa,EAAE,gBAAgB;EAC/B,6BAA6B,EAAE,qBAAqB;EACpD,uCAAuC,EAAE,iBAAiB;EAC1D,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B,EAAE,iBAAiB;EAC7C,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB,EAAE,mBAAmB;AACvC;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,4BAA4B,EAAE,gBAAgB;EAC9C,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB,EAAE,gBAAgB;EACnC,iBAAiB,EAAE,iBAAiB;AACtC;;AAEA,uEAAuE;AACvE;EACE,aAAa,EAAE,kCAAkC;EACjD,2DAA2D;EAC3D,SAAS,EAAE,kBAAkB;EAC7B,gBAAgB;EAChB,iBAAiB,EAAE,mBAAmB;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,6BAA6B,EAAE,UAAU;EACzC,uCAAuC,EAAE,sBAAsB;EAC/D,sCAAsC;EACtC,oBAAoB,EAAE,qBAAqB;EAC3C,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC,EAAE,iBAAiB;EACrD,8BAA8B,EAAE,eAAe;EAC/C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB,EAAE,WAAW;AAC/B;;AAEA;EACE,4BAA4B,EAAE,qBAAqB;EACnD,kBAAkB;EAClB,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA,uDAAuD;AACvD;EACE,2EAA2E;EAC3E,oBAAoB;EACpB,wCAAwC;EACxC,2CAA2C;EAC3C,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;EACxC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oCAAoC,EAAE,eAAe;EACrD,yBAAyB,EAAE,aAAa;EACxC,4CAA4C,EAAE,8BAA8B;EAC5E,wCAAwC;EACxC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B,EAAE,mBAAmB;EACnD,YAAY,EAAE,eAAe;EAC7B,2BAA2B;EAC3B,sCAAsC;AACxC;;;AAGA,mCAAmC;AACnC;EACE;IACE,uBAAuB,EAAE,mBAAmB;IAC5C,iCAAiC;EACnC;;EAEA,qBAAqB,iBAAiB,EAAE;EACxC,iBAAiB,iBAAiB,EAAE,mBAAmB,EAAE;EACzD,mBAAmB,iBAAiB,EAAE;EACtC,mBAAmB,0BAA0B,EAAE,WAAW,EAAE;EAC5D,gBAAgB,eAAe,EAAE;EACjC,aAAa,0BAA0B,EAAE,iBAAiB,EAAE;EAC5D,aAAa,aAAa,EAAE;EAC5B,iBAAiB,0BAA0B,EAAE,iBAAiB,EAAE,WAAW,EAAE;EAC7E,gBAAgB,kBAAkB,EAAE;EACpC,eAAe,mBAAmB,EAAE,oBAAoB,EAAE;EAC1D,iBAAiB,aAAa,EAAE,iBAAiB,EAAE,EAAE,yBAAyB;AAChF;;AAEA;EACE,kBAAkB,yBAAyB,EAAE,iCAAiC,EAAE;EAChF,qBAAqB,iBAAiB,EAAE;EACxC,iBAAiB,eAAe,EAAE;EAClC,sBAAsB,iBAAiB,EAAE,mBAAmB,EAAE;EAC9D,aAAa,iBAAiB,EAAE;EAChC,gBAAgB,eAAe,EAAE;EACjC,mBAAmB,iBAAiB,EAAE;EACtC,aAAa,eAAe,EAAE;EAC9B,gBAAgB,iBAAiB,EAAE;EACnC,gBAAgB,eAAe,EAAE;EACjC,aAAa,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;EAC3D,mBAAmB,iBAAiB,EAAE;EACtC,eAAe,oBAAoB,EAAE;EACrC,kBAAkB,iBAAiB,EAAE;EACrC,cAAc,oBAAoB,EAAE,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;EACpF,oBAAoB,iBAAiB,EAAE;AACzC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,sCAAsC;EACtC,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,4BAA4B;EAC5B,sCAAsC;EACtC,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa,0BAA0B,EAAE,iBAAiB,EAAE;EAC5D,aAAa,eAAe,EAAE;EAC9B,wBAAwB,iBAAiB,EAAE;AAC7C","sourcesContent":["/* Pages.css - UPDATED FOR LIGHT THEME */\n\n/* General page container with proper navbar spacing */\n.page-container {\n  min-height: calc(100vh - var(--navbar-height)); /* Use global navbar height */\n  padding: 2rem 1rem 4rem;\n  /* background: var(--gradient-hero); /* Replaced complex gradient */\n  padding-top: var(--navbar-height);\n  /* Use a simpler light background */\n  background-color: var(--bg-secondary); /* Use light secondary background */\n}\n\n.page-container .content-section h2 {\n  text-align: center; /* Center the h2 heading within the content section */\n  margin-bottom: 2.5rem; /* Add a bit more space below the centered heading */\n}\n\n.page-container h1 {\n  text-align: center;\n  font-size: 2.8rem;\n  color: var(--text-primary); /* Dark text */\n  margin-bottom: 1rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.page-subtitle {\n  text-align: center;\n  font-size: 1.2rem;\n  color: var(--text-secondary); /* Medium gray text */\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.5;\n  margin-bottom: 2rem; /* Added margin */\n}\n\n.content-section {\n  max-width: 900px;\n  margin: 0 auto 3rem;\n  color: var(--text-primary); /* Dark text */\n  line-height: 1.8;\n  padding: 0 1rem;\n}\n\n.content-section h2 {\n  color: var(--text-accent); /* Red accent text */\n  margin: 3rem 0 1.5rem;\n  font-size: 1.8rem;\n  font-weight: 500;\n}\n\n.lead-text {\n  font-size: 1.3rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  font-weight: 400;\n  color: var(--text-secondary); /* Medium gray text */\n}\n\n/* CTA Section (Light Theme) */\n.cta-section {\n  text-align: center;\n  margin: 4rem auto;\n  padding: 3rem 2rem;\n  background: var(--bg-primary); /* White background */\n  border-radius: var(--border-radius-2xl);\n  border: 1px solid var(--border-primary); /* Light gray border */\n  max-width: 800px;\n  box-shadow: var(--shadow-xl); /* Add shadow */\n}\n\n.cta-section h2 {\n  color: var(--text-primary); /* Dark text */\n  margin-bottom: 2rem;\n  font-size: 2rem;\n}\n\n/* Contact Page Layout - Simplified for light theme */\n.contact-content {\n  display: grid;\n  grid-template-columns: 1fr; /* Stack info and form */\n  gap: 3rem; /* Adjusted gap */\n  max-width: 700px; /* Narrower max-width */\n  margin: 0 auto;\n  align-items: start;\n}\n\n.contact-info h2 {\n  color: var(--text-accent); /* Red accent */\n  margin-bottom: 1.5rem;\n  font-size: 2rem;\n  text-align: center;\n}\n\n.contact-info p {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n  color: var(--text-secondary); /* Medium gray */\n  text-align: center;\n}\n\n.contact-details {\n  margin-top: 2rem;\n  display: grid; /* Use grid for details too */\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n}\n\n.contact-item {\n  margin-bottom: 0; /* Remove margin as grid handles gap */\n  padding: 1.5rem;\n  background: var(--bg-secondary); /* Light gray background */\n  border-radius: var(--border-radius-lg);\n  border: 1px solid var(--border-primary); /* Light border */\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.contact-item:hover {\n  border-color: var(--text-accent); /* Red border */\n  background: var(--bg-primary); /* White on hover */\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-lg);\n}\n\n.contact-item h3 {\n  color: var(--text-primary); /* Dark text */\n  margin-bottom: 0.8rem;\n  font-size: 1.3rem;\n}\n\n.contact-item p, .contact-item a {\n  color: var(--text-secondary); /* Medium gray */\n  font-size: 1rem;\n  text-decoration: none;\n}\n.contact-item a:hover {\n  color: var(--text-accent); /* Red link hover */\n}\n\n/* Contact Form Styling (Light Theme) */\n.contact-form-section h2 {\n  color: var(--text-accent); /* Red accent */\n  margin-bottom: 2rem;\n  font-size: 2rem;\n  text-align: center;\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.contact-form .form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-form label {\n  color: var(--text-primary); /* Dark label */\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  font-size: 1rem;\n}\n\n.contact-form input,\n.contact-form textarea {\n  width: 100%;\n  padding: 1rem 1.2rem;\n  border: 1px solid var(--border-primary); /* Light border */\n  border-radius: var(--border-radius-lg);\n  background: var(--bg-secondary); /* Light gray background */\n  color: var(--text-primary); /* Dark text */\n  font-size: 1rem;\n  font-family: inherit;\n  resize: vertical;\n  transition: all 0.3s ease;\n}\n\n.contact-form input:focus,\n.contact-form textarea:focus {\n  outline: none;\n  border-color: var(--text-accent); /* Red border */\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15); /* Red ring */\n  background: var(--bg-primary); /* White background */\n}\n\n.contact-form textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.contact-form input::placeholder,\n.contact-form textarea::placeholder {\n  color: #9CA3AF; /* gray-400 equivalent */\n}\n\n/* Blog Page Layout (Light Theme) */\n.blog-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); /* Adjusted min size */\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 1rem; /* Add padding */\n}\n\n.blog-card {\n  background: var(--bg-primary); /* White background */\n  border: 1px solid var(--border-primary); /* Light border */\n  border-radius: var(--border-radius-xl); /* Consistent rounding */\n  padding: 2rem; /* Adjusted padding */\n  transition: all 0.3s ease;\n  height: auto; /* Allow natural height */\n  box-shadow: var(--shadow-lg);\n}\n\n.blog-card:hover {\n  transform: translateY(-5px);\n  border-color: var(--text-accent); /* Red border */\n  box-shadow: var(--shadow-xl);\n}\n\n.blog-card h2 {\n  color: var(--text-primary); /* Dark text */\n  font-size: 1.5rem;\n  margin-bottom: 0.8rem;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.blog-date {\n  color: var(--text-secondary); /* Medium gray */\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  font-weight: 500;\n}\n\n.blog-excerpt {\n  color: var(--text-secondary); /* Medium gray */\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n  font-size: 0.95rem;\n}\n\n.read-more {\n  color: var(--text-accent); /* Red accent */\n  text-decoration: none;\n  font-weight: 600; /* Bolder */\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.read-more:hover {\n  color: var(--primary-red-dark); /* Darker red */\n  transform: translateX(5px);\n}\n\n/* Legal Pages Layout (Light Theme) */\n.legal-content {\n  max-width: 800px;\n  margin: 2rem auto; /* Added top margin */\n  color: var(--text-secondary); /* Medium gray base text */\n  line-height: 1.8;\n  padding: 2rem; /* Add padding */\n  background: var(--bg-primary); /* White background */\n  border: 1px solid var(--border-primary); /* Light border */\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-lg);\n}\n\n.legal-content h2 {\n  color: var(--text-primary); /* Dark heading */\n  margin: 3rem 0 1.5rem;\n  font-size: 1.8rem;\n  font-weight: 600; /* Bolder heading */\n}\n\n.legal-content p {\n  margin-bottom: 1.5rem;\n  font-size: 1rem;\n}\n\n.last-updated {\n  color: var(--text-secondary); /* Medium gray */\n  font-style: italic;\n  margin-bottom: 2rem;\n  text-align: right; /* Align right */\n  font-size: 0.9rem; /* Smaller text */\n}\n\n/* Process Steps Layout (Looks okay, uses light theme styles already) */\n.process-steps {\n  display: grid; /* Use grid for better alignment */\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem; /* Increased gap */\n  margin-top: 3rem;\n  max-width: 1100px; /* Adjusted width */\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0 1rem;\n}\n.process-step {\n  background: var(--bg-primary); /* White */\n  border: 1px solid var(--border-primary); /* Light gray border */\n  border-radius: var(--border-radius-xl);\n  padding: 2rem 1.5rem; /* Adjusted padding */\n  text-align: center;\n  transition: all 0.3s ease;\n  position: relative;\n  box-shadow: var(--shadow-lg);\n}\n\n.process-step:hover {\n  transform: translateY(-5px);\n  border-color: var(--text-accent);\n  box-shadow: var(--shadow-xl);\n}\n\n.step-icon {\n  width: 60px;\n  height: 60px;\n  background: var(--gradient-button); /* Red gradient */\n  color: var(--text-on-gradient); /* White text */\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.5rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  box-shadow: var(--shadow-lg);\n}\n\n.process-step h3 {\n  color: var(--text-primary); /* Dark text */\n  margin-bottom: 1rem;\n  font-size: 1.3rem;\n  font-weight: 600; /* Bolder */\n}\n\n.process-step p {\n  color: var(--text-secondary); /* Medium gray text */\n  font-size: 0.95rem;\n  line-height: 1.6; /* Increased line height */\n}\n\n/* CTA Button Styling (Use primary auth button style) */\n.cta-button.primary {\n  /* Inherit from .auth-button if available globally, otherwise define here */\n  display: inline-flex;\n  background-image: var(--gradient-button);\n  background-color: var(--primary-red-medium);\n  color: white;\n  padding: 1rem 2.5rem;\n  border-radius: var(--border-radius-full);\n  text-decoration: none;\n  font-size: 1.1rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n  border: none;\n  box-shadow: var(--shadow-lg);\n}\n\n.cta-button.primary:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-button-hover);\n}\n\n/* Secondary CTA Button (Light theme adaptation) */\n.cta-button.secondary {\n  display: inline-flex;\n  background: transparent;\n  border: 2px solid var(--text-accent); /* Red border */\n  color: var(--text-accent); /* Red text */\n  padding: calc(1rem - 2px) calc(2.5rem - 2px); /* Adjust padding for border */\n  border-radius: var(--border-radius-full);\n  text-decoration: none;\n  font-size: 1.1rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n}\n\n.cta-button.secondary:hover {\n  background: var(--text-accent); /* Red background */\n  color: white; /* White text */\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-button-hover);\n}\n\n\n/* Responsive Design Improvements */\n@media (max-width: 768px) {\n  .page-container {\n    padding: 3rem 1rem 3rem; /* Adjust padding */\n    padding-top: var(--navbar-height);\n  }\n\n  .page-container h1 { font-size: 2.2rem; }\n  .page-subtitle { font-size: 1.1rem; margin-bottom: 2rem; }\n  .content-section { padding: 0 0.5rem; }\n  .contact-content { grid-template-columns: 1fr; gap: 2.5rem; }\n  .contact-item { padding: 1.5rem; }\n  .blog-grid { grid-template-columns: 1fr; padding: 0 0.5rem; }\n  .blog-card { padding: 2rem; }\n  .process-steps { grid-template-columns: 1fr; padding: 0 0.5rem; gap: 1.5rem; }\n  .process-step { padding: 2rem 1rem; }\n  .cta-section { margin: 2rem 0.5rem; padding: 2rem 1.5rem; }\n  .legal-content { padding: 1rem; margin: 1rem auto; } /* Adjust legal padding */\n}\n\n@media (max-width: 480px) {\n  .page-container { padding: 2rem 0.5rem 2rem; padding-top: var(--navbar-height); }\n  .page-container h1 { font-size: 1.8rem; }\n  .page-subtitle { font-size: 1rem; }\n  .content-section h2 { font-size: 1.5rem; margin: 2rem 0 1rem; }\n  .lead-text { font-size: 1.1rem; }\n  .contact-item { padding: 1.2rem; }\n  .contact-item h3 { font-size: 1.1rem; }\n  .blog-card { padding: 1.5rem; }\n  .blog-card h2 { font-size: 1.3rem; }\n  .process-step { padding: 1.5rem; }\n  .step-icon { width: 50px; height: 50px; font-size: 1.2rem; }\n  .process-step h3 { font-size: 1.1rem; }\n  .cta-section { padding: 1.5rem 1rem; }\n  .cta-section h2 { font-size: 1.6rem; }\n  .cta-button { padding: 0.8rem 2rem; font-size: 1rem; width: 100%; max-width: 300px; }\n  .legal-content h2 { font-size: 1.4rem; }\n}\n\n/* Blog Page Layout */\n.blog-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n}\n\n.blog-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--border-radius-xl);\n  padding: 2rem;\n  transition: all 0.3s ease;\n  height: auto;\n  box-shadow: var(--shadow-lg);\n}\n\n.blog-card:hover {\n  transform: translateY(-5px);\n  border-color: var(--text-accent);\n  box-shadow: var(--shadow-xl);\n}\n\n.blog-card h2 {\n  color: var(--text-primary);\n  font-size: 1.5rem;\n  margin-bottom: 0.8rem;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.blog-card-thumbnail {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  border-radius: var(--border-radius-lg);\n  margin-bottom: 1.25rem;\n}\n\n.blog-date {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  font-weight: 500;\n}\n\n.blog-excerpt {\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n  font-size: 0.95rem;\n}\n\n.blog-error {\n  text-align: center;\n  color: var(--text-secondary);\n  max-width: 600px;\n  margin: 2rem auto;\n  font-size: 1.05rem;\n}\n\n.read-more {\n  color: var(--text-accent);\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.read-more:hover {\n  color: var(--primary-red-dark);\n  transform: translateX(5px);\n}\n\n/* Blog Post Detail Page */\n.blog-post-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n}\n\n.blog-back-link {\n  display: inline-block;\n  margin-bottom: 1.5rem;\n  color: var(--text-accent);\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.blog-back-link:hover {\n  color: var(--primary-red-dark);\n}\n\n.blog-post-thumbnail {\n  width: 100%;\n  max-height: 420px;\n  object-fit: cover;\n  border-radius: var(--border-radius-xl);\n  margin-bottom: 1.5rem;\n}\n\n.blog-post-article h1 {\n  color: var(--text-primary);\n  font-size: 2.2rem;\n  line-height: 1.3;\n  margin-bottom: 0.5rem;\n}\n\n.blog-post-categories {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin: 0.75rem 0 1.5rem;\n}\n\n.blog-post-category-tag {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  color: var(--text-secondary);\n  border-radius: var(--border-radius-lg);\n  padding: 0.25rem 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.blog-post-content {\n  color: var(--text-primary);\n  font-size: 1.05rem;\n  line-height: 1.8;\n}\n\n.blog-post-content img {\n  max-width: 100%;\n  height: auto;\n  border-radius: var(--border-radius-lg);\n  margin: 1rem 0;\n}\n\n.blog-post-content a {\n  color: var(--text-accent);\n}\n\n.blog-post-content blockquote {\n  border-left: 4px solid var(--text-accent);\n  padding-left: 1rem;\n  color: var(--text-secondary);\n  font-style: italic;\n  margin: 1.5rem 0;\n}\n\n@media (max-width: 768px) {\n  .blog-grid { grid-template-columns: 1fr; padding: 0 0.5rem; }\n  .blog-card { padding: 1.5rem; }\n  .blog-post-article h1 { font-size: 1.6rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
